import * as React from "react";

export default function(props:{show:boolean; label?:string|null;}) {
  if(props.show) {
    return (
      <React.Fragment>
        {props.label && <p className="error">{props.label}</p> }
        <div className={"invalidBubble"}></div>
      </React.Fragment>
    );
  } else {
    return null;
  }
}
